import payment from './payment'
import shipping from './shipping'

export default {
  payment,
  shipping
}
